<template>
  <div class="container-fluid" style="padding-left: 0px; padding-right: 0px;">
    <div class="pageContainer">
      <div class="row">
        <div class="col-sm-12">
          <div class="pageSubContainer">
            <div class="row">
              <div class="col-sm-12">
                <form name="add" @submit.prevent="createOrder">
                <div class="pageCard">
                  <div class="row">
                    <div class="col-sm-2">
                      Customer
                    </div>
                    <div class="col-sm-4">
                      <v-select v-model="order.company_id" :options="companies" :reduce="companies => companies.id" label="name" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <hr />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-12">
                      <div class="row">
                          <div class="col-sm-2">
                            <label style="text-align: left;">Job Type</label>
                          </div>
                          <div class="col-sm-4">
                            <div class="commerceSelect">
                                <select v-model="order.type">
                                  <option value="Job">Job</option>
                                  <option value="Refrigeration Maintenance">Refrigeration Maintenance</option>
                                  <option value="Maintenance">Large Maintenance</option>
                                  <option value="Air Con">Air Conditioning Report</option>
                                  <option value="Temperature Check" disabled>Temperature Check</option>
                                </select>
                              </div>
                          </div>
                        </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-2">
                      <label style="text-align:left;">Job Description</label>
                    </div>
                    <div class="col-sm-10">
                      <textarea v-model="order.job_description" rows="5" placeholder="Job Description"></textarea>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-12">
                      <div class="row">
                          <div class="col-sm-2">
                            <label style="text-align: left;">Engineer</label>
                          </div>
                          <div class="col-sm-4">
                            <div class="commerceSelect">
                                <select v-model="order.engineer">
                                  <option value="Will Rae">Will Rae</option>
                                  <option value="Ben White">Ben White</option>
                                  
                                </select>
                              </div>
                          </div>
                        </div>
                    </div>
                  </div>


                  <div class="row">
                    <div class="col-sm-1">
                      
                    </div>
                    <div class="col-sm-3">
                     
                    </div>
                    <div class="col-sm-8">
                      <div align="right">
                        <input type="submit" value="Create Job">
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              </div>
              
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'

export default {
  data () {
    return {
      companies: [],
      productInput: null,
      isVisible: false,
      variants: [],
      order: []
    }
  },
  created () {
    axios
      .get('/api/companies/companies_list/')
      .then(response => {
        this.companies = response.data
      })
  },
  watch: {
    productInput (after, before) {
      if (after === null || before === null) {
        this.DoNothing()
      } else {
        this.searchProduct()
      }
    }
  },
  methods: {
    onFocus: function () {
      this.isVisible = true
    },
    onBlur: function () {
      // this.isVisible = false
    },
    searchProduct () {
      const keywords = { keywords: this.productInput }
      axios
        .post('/api/variants/search', keywords)
        .then(response => {
          this.variants = response.data
        })
    },
    createOrder (variant) {
      const neworder = {
        variant_id: variant,
        company_id: this.order.company_id,
        currency: 'GBP',
        type: this.order.type,
        engineer: this.order.engineer,
        job_description: this.order.job_description,
        customer_reference: this.order.customer_reference,
      }
      axios
        .post('/api/orders/new', neworder)
        .then(response => {
          this.$toast.success("Job created", {})
          if (this.order.type=="Job") {
            this.$router.push({ name: 'OrdersEdit', params: { id: response.data.id } })
          }
          if (this.order.type=="Refrigeration Maintenance") {
            this.$router.push({ name: 'OrdersRefridgerationEdit', params: { id: response.data.id } })
          }
          if (this.order.type=="Air Con") {
            this.$router.push({ name: 'OrdersAirconEdit', params: { id: response.data.id } })
          }
          if (this.order.type=="Maintenance") {
            this.$router.push({ name: 'MaintenanceEdit', params: { id: response.data.id } })
          }
        })
    }
  }
}
</script>
